module.exports = __webpack_public_path__ + "img/793.676c561f.jpg";